import React from "react";
import "./OurSalon.css";

const OurSalonHead = () => {
  return (
      <div className="salonContent1">
        <p>From one salon to a thousand transformation stories.</p>
        <div className="salonUnderline"></div>
      </div>
  );
};

export default OurSalonHead;
